import { Translation } from '@ngneat/transloco';

type JsonValue = string | number | boolean | null | JsonValue[] | { [key: string]: JsonValue };

const TERMINOLOGY_REPLACEMENTS: Array<[RegExp, string]> = [
  [/\bObservations\b/g, 'Transactions'],
  [/\bObservation\b/g, 'Transaction'],
  [/\bobservations\b/g, 'transactions'],
  [/\bobservation\b/g, 'transaction'],
  [/\bOBSERVATIONS\b/g, 'TRANSACTIONS'],
  [/\bOBSERVATION\b/g, 'TRANSACTION'],
  [/\bProject Buildings\b/g, 'Projects'],
  [/\bProject Building\b/g, 'Project'],
  [/\bproject buildings\b/g, 'projects'],
  [/\bproject building\b/g, 'project'],
  [/\bPROJECT BUILDINGS\b/g, 'PROJECTS'],
  [/\bPROJECT BUILDING\b/g, 'PROJECT'],
  [/\bBuildings\b/g, 'Projects'],
  [/\bBuilding\b/g, 'Project'],
  [/\bbuildings\b/g, 'projects'],
  [/\bbuilding\b/g, 'project'],
  [/\bBUILDINGS\b/g, 'PROJECTS'],
  [/\bBUILDING\b/g, 'PROJECT'],
  [/الملاحظات/g, 'المعاملات'],
  [/ملاحظات/g, 'معاملات'],
  [/الملاحظة/g, 'المعاملة'],
  [/ملاحظة/g, 'معاملة'],
  [/مباني المشروع/g, 'المشاريع'],
  [/المباني/g, 'المشاريع'],
  [/مبانٍ/g, 'مشاريع'],
  [/مباني/g, 'مشاريع'],
  [/المبنى/g, 'المشروع'],
  [/مبنى/g, 'مشروع'],
  [/замечания/g, 'транзакции'],
  [/Замечания/g, 'Транзакции'],
  [/замечаний/g, 'транзакций'],
  [/Замечаний/g, 'Транзакций'],
  [/замечание/g, 'транзакция'],
  [/Замечание/g, 'Транзакция'],
  [/замечании/g, 'транзакции'],
  [/Замечании/g, 'Транзакции'],
  [/замечанию/g, 'транзакции'],
  [/Замечанию/g, 'Транзакции'],
  [/(^|[\s"'«(])Здания проекта(?=$|[\s"',.:;!?»)\]])/g, '$1Проекты'],
  [/(^|[\s"'«(])здания проекта(?=$|[\s"',.:;!?»)\]])/g, '$1проекты'],
  [/(^|[\s"'«(])Зданиями(?=$|[\s"',.:;!?»)\]])/g, '$1Проектами'],
  [/(^|[\s"'«(])зданиями(?=$|[\s"',.:;!?»)\]])/g, '$1проектами'],
  [/(^|[\s"'«(])Зданий(?=$|[\s"',.:;!?»)\]])/g, '$1Проектов'],
  [/(^|[\s"'«(])зданий(?=$|[\s"',.:;!?»)\]])/g, '$1проектов'],
  [/(^|[\s"'«(])Здания(?=$|[\s"',.:;!?»)\]])/g, '$1Проекта'],
  [/(^|[\s"'«(])здания(?=$|[\s"',.:;!?»)\]])/g, '$1проекта'],
  [/(^|[\s"'«(])Здание(?=$|[\s"',.:;!?»)\]])/g, '$1Проект'],
  [/(^|[\s"'«(])здание(?=$|[\s"',.:;!?»)\]])/g, '$1проект'],
  [/(^|[\s"'«(])Здании(?=$|[\s"',.:;!?»)\]])/g, '$1Проекте'],
  [/(^|[\s"'«(])здании(?=$|[\s"',.:;!?»)\]])/g, '$1проекте'],
];

export function applyNwcTerminologyToText(value: string): string {
  return TERMINOLOGY_REPLACEMENTS.reduce(
    (currentValue, [pattern, replacement]) => currentValue.replace(pattern, replacement),
    value,
  );
}

export function applyNwcTerminologyToTranslation<T extends Translation>(translation: T): T {
  return transformValue(translation) as T;
}

function transformValue(value: JsonValue): JsonValue {
  if (typeof value === 'string') {
    return applyNwcTerminologyToText(value);
  }

  if (Array.isArray(value)) {
    return value.map((item) => transformValue(item));
  }

  if (value !== null && typeof value === 'object') {
    const transformed: { [key: string]: JsonValue } = {};

    for (const [key, nestedValue] of Object.entries(value)) {
      transformed[key] = transformValue(nestedValue);
    }

    return transformed;
  }

  return value;
}
